import { Icon20Stars, Icon20WriteOutline, Icon28PicturePenOutline } from '@vkontakte/icons';
import { Spacing } from '@vkontakte/vkui';
import React from 'react';
import {
    isAnimatedBanner,
    isShowAiTooltipOnMediaFilesFeature,
} from 'reactApp/appHelpers/featuresHelpers/features/aiGenerateAndEditMediaContentFakedoor';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { sendDwh, sendXray } from 'reactApp/utils/ga';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './AiGenerateAndEditFakedoorModal.css';

const sendRadar = (action: 'show' | 'click' | 'close', isSecondStep = false) => {
    const isCoolVariant = isAnimatedBanner && isShowAiTooltipOnMediaFilesFeature;
    const postfix = isCoolVariant ? '_cool' : '';

    sendXray([isSecondStep ? `ai-fakedoor-2s-modal${postfix}` : `ai-fakedoor-modal${postfix}`, action]);
    sendDwh({
        eventCategory: 'modal',
        action,
        dwhData: { name: isSecondStep ? `fakedoor_generate_edit_media_thanks${postfix}` : `fakedoor_generate_edit_media${postfix}` },
    });
};

const renderSecondStepModal = () => {
    const isDarkTheme = isDarkThemeModeEnabled();

    sendRadar('show', true);

    return renderCommonWhatsNewDialog({
        title: <span>Спасибо за&nbsp;интерес</span>,
        content: (
            <div data-test-id="ai-fakedoor-modal">
                <Spacing size={16} />
                <span>Мы&nbsp;ещё&nbsp;работаем над&nbsp;этими возможностями. Сообщим сразу, как&nbsp;появятся</span>
                <Spacing size={24} />
            </div>
        ),
        secondaryButtonText: 'Закрыть',
        imageUrl: '',
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: (
            <div className={styles.secondStepIllustrationWrapper}>
                <img
                    className={styles.secondStepImage}
                    src={`${cdnPackagesUrl}/static/cloud/ai/fakedoor/in-progress${isDarkTheme ? '-dark' : ''}.png`}
                />
            </div>
        ),
        onSecondary: () => {
            sendRadar('close', true);
        },
        onDismiss: () => {
            sendRadar('close', true);
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        className: styles.root,
        contentClassName: styles.content,
        closeAfterClick: true,
        closeIconClassName: styles.closeIcon,
        closeIconWrapperClassName: styles.closeIconWrapper,
    });
};

interface RenderAiGenerateAndEditFakedoorModalParams {
    onComplete?: () => void;
    onClose?: () => void;
}

export const renderAiGenerateAndEditFakedoorModal = (params?: RenderAiGenerateAndEditFakedoorModalParams) => {
    // eslint-disable-next-line init-declarations, prefer-const
    let closeDialog: (() => void) | undefined;

    const primaryClickHandler = () => {
        sendRadar('click');
        closeDialog?.();
        params?.onComplete?.();
        renderSecondStepModal();
    };

    closeDialog = renderCommonWhatsNewDialog({
        title: <span>Фото станут ещё&nbsp;лучше&nbsp;— с&nbsp;нейросетью в&nbsp;Mail&nbsp;Space</span>,
        content: (
            <div data-test-id="ai-fakedoor-modal">
                <Spacing size={16} />
                <div className={styles.descriptionLine}>
                    <Icon20Stars className={styles.icon} />
                    <span>Нейросеть повысит качество фото</span>
                </div>
                <Spacing size={12} />

                <div className={styles.descriptionLine}>
                    <Icon28PicturePenOutline className={styles.icon} height={20} width={20} />
                    <span>Уберёт лишний предмет или&nbsp;целый фон</span>
                </div>
                <Spacing size={12} />

                <div className={styles.descriptionLine}>
                    <Icon20WriteOutline className={styles.icon} />
                    <span>Сгенерирует фото или&nbsp;картинку по&nbsp;описанию</span>
                </div>
                <Spacing size={24} />
            </div>
        ),
        primaryButtonText: <span>Попробовать за&nbsp;1&nbsp;₽</span>,
        imageUrl: '',
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: (
            <video src={`${cdnPackagesUrl}/static/cloud/ai/fakedoor/modal-2x.mp4`} autoPlay muted loop className={styles.video} />
        ),
        onClick: primaryClickHandler,
        onDismiss: () => {
            params?.onClose?.();
            sendRadar('close');
        },
        onShow: () => {
            sendRadar('show');
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        className: styles.root,
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        closeIconWrapperClassName: styles.closeIconWrapper,
    })?.closeDialog;
};
